import './dashboard.css'
import { Link, Outlet } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from "../assets/Alien-Blank.png";
import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import InsightsIcon from '@mui/icons-material/Insights';
import YoutubeSearchedForIcon from '@mui/icons-material/YoutubeSearchedFor';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
//import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';


function DashNav() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <MenuOpenIcon onClick={handleShow} className='dashNavIcon'/>
      <Offcanvas show={show} onHide={handleClose} backdrop={false} scroll className='DashOffcanvas'>
        <Offcanvas.Header closeButton closeVariant='white'>
          <Offcanvas.Title><img
              alt=""
              src={Logo}
              width="45"
              height="45"
              className="d-inline-block align-center"
         />   Dashboard</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <NavDropdown className='dashNavLink' title="Dashboard" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} className='dashNavLink' to="/dashboard/cards">Search</NavDropdown.Item>
            <NavDropdown.Item as={Link} className='dashNavLink' to="/dashboard/cracked">Cracked Cards</NavDropdown.Item>
            <NavDropdown.Item as={Link} className='dashNavLink' to="/dashboard/sold">Sold Reports</NavDropdown.Item>
            <NavDropdown.Divider />
          </NavDropdown>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/card-wall"><WallpaperIcon /> Card Wall</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/"><DeveloperBoardIcon /> Dashboard Home</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/search"><SearchRoundedIcon /> Card Database</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/cards/new"><YoutubeSearchedForIcon /> Newest Cards</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/financials"><InsightsIcon /> Financials</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/sold"><LocalAtmIcon /> Sold Reports</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/submissions"><CardMembershipIcon /> Submissions</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/cracked"><CompareArrowsIcon /> Cracked Cards</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/tags/psa-vault"><WallpaperIcon /> PSA Vault</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/tags"><LocalOfferIcon /> Tags</Nav.Link>
          <Nav.Link as={Link} className='dashNavLink' to="/dashboard/users"><ManageAccountsIcon /> Users</Nav.Link>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}


function dashboard() {
  return (
    <div>
      <div className='dashboard'>
        <div className='dashNav'>
          <div className='dashNavLinks'>
          <DashNav key='DashNav' placement='start' name='DashNav' />
          </div>
          <div className='dashNavLinks'>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/card-wall"><WallpaperIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/"><DeveloperBoardIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/search"><SearchRoundedIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/cards/new"><YoutubeSearchedForIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/financials"><InsightsIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/sold"><LocalAtmIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/cracked"><CompareArrowsIcon /></Nav.Link></div>
            {/* <div className='dashNavLink'><Nav.Link href="/dashboard/sold"><PointOfSaleIcon /></Nav.Link></div> */}
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/submissions"><CardMembershipIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/tags"><LocalOfferIcon /></Nav.Link></div>
            <div className='dashNavLink'><Nav.Link as={Link} to="/dashboard/users"><ManageAccountsIcon /></Nav.Link></div>
          </div>
        </div>
        <div className='dashContent'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default dashboard
